import { useContext } from "react";
import { ThemeContext } from "styled-components";
import defaultTheme from "../defaultTheme";

var useTheme = function useTheme() {
  return useContext(ThemeContext) || defaultTheme;
};

export default useTheme;